import { render, staticRenderFns } from "./EditarCita.vue?vue&type=template&id=32f7015c&scoped=true"
import script from "./EditarCita.vue?vue&type=script&lang=js"
export * from "./EditarCita.vue?vue&type=script&lang=js"
import style0 from "./EditarCita.vue?vue&type=style&index=0&id=32f7015c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7015c",
  null
  
)

export default component.exports